import React, { useState, useEffect } from 'react';
import Popup from './Popup';
import './WarningPopup.css';

const WarningPopup = ({ children, popupName }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const isDismissed = localStorage.getItem(popupName);
        if (!isDismissed) {
            setIsVisible(true);
        }
    }, [popupName]);

    const handleDismiss = () => {
        setIsVisible(false);
        localStorage.setItem(popupName, 'true');
    };

    if (!isVisible) return null;

    return (
        <Popup 
            onClose={handleDismiss} 
            overlayClassName="warning-popup-mobile"
            title="Warning"
        >
            <p>{children}</p>
            <div className="popup-buttons">
                <button 
                    className="popup-primary-button" 
                    onClick={handleDismiss}
                >
                    Dismiss
                </button>
            </div>
        </Popup>
    );
};

export default WarningPopup;